import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/fillClose.svg';

export const IconFillClose = createIconComponent(Icon);
